import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ToggleOpenSidebarIcon: FC<Props> = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5283 14.6335C13.8431 14.8495 13.9234 15.2806 13.7065 15.5963C13.5726 15.792 13.3557 15.8963 13.1351 15.8963C13.0003 15.8963 12.8637 15.8566 12.7437 15.7745C11.432 14.8745 9.23231 13.1862 9.23231 12.0009C9.23231 10.8166 11.432 9.12738 12.7437 8.22646C13.0612 8.01046 13.4905 8.08985 13.7065 8.40461C13.9234 8.71938 13.844 9.15046 13.5283 9.36738C12.0662 10.3735 10.7037 11.6169 10.6151 12.0295C10.7037 12.3849 12.0662 13.6283 13.5283 14.6335ZM11.8077 3C5.16246 3 2.80769 5.35569 2.80769 12C2.80769 18.6452 5.16246 21 11.8077 21C18.452 21 20.8077 18.6452 20.8077 12C20.8077 5.35569 18.452 3 11.8077 3Z"
        fill={props.fill || "currentColor"} // "#52565C"
      />
    </svg>
  );
};

export default ToggleOpenSidebarIcon;
